export default __webpack_public_path__ + "static/media/halal.70069ca0.webp";